/**
 * Limite degli upload multipart che passano dal backend (documenti, allegati,
 * scontrini, logo...). Cloudflare rifiuta con 413 i corpi oltre 100 MB: 95 MB
 * lascia margine per gli altri campi. Le prove vanno al bucket e non sono limitate.
 */
export const MAX_UPLOAD_MB = 95;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

export const uploadTooLargeMessage = (sizeBytes?: number): string => {
    const sizeTxt = sizeBytes ? ` (${(sizeBytes / (1024 * 1024)).toFixed(0)} MB)` : '';
    return `File troppo grande${sizeTxt}: il limite è ${MAX_UPLOAD_MB} MB per file.`;
};

/** Somma delle dimensioni dei file contenuti in un FormData (0 se nessun file). */
export const formDataFilesBytes = (fd: FormData): number => {
    let total = 0;
    fd.forEach((v) => {
        if (typeof Blob !== 'undefined' && v instanceof Blob) total += v.size;
    });
    return total;
};
